import React, { Component } from 'react'
import { object, func } from 'prop-types'
import { isUri } from 'valid-url'

class WorkflowStepLink extends Component {
  constructor (props) {
    super(props)

    this.state = {
      error: false,
      submitting: false
    }
  }
  render () {
    const { completed, link, _id } = this.props.step
    if (completed) {
      return (
        <div className='pull-right'>
          <a href={link} className='btn btn-link' target='_blank'>
            Acessar
          </a>
        </div>
      )
    } else {
      return (
        <div>
          <input
            className='form-control'
            type='input'
            placeholder='Link para youtube'
            ref={input => {
              this.input = input
            }}
          />
          {this.state.error &&
            <small className='text-danger'>A URL não parece válida. Verifique e tente novamente.</small>
          }
          <div className='pull-right mt20'>
            <button
              className='btn btn-primary btn-sm'
              onClick={() => {
                if (isUri(this.input.value)) {
                  this.setState({ error: false, submitting: true })
                  this.props.submit(_id, 'link', this.input.value)
                } else {
                  this.setState({ error: true })
                }
              }}
              disabled={this.state.submitting}
            >Enviar</button>
          </div>
        </div>
      )
    }
  }
}

WorkflowStepLink.propTypes = {
  step: object,
  submit: func
}

export default WorkflowStepLink



// WEBPACK FOOTER //
// ./src/components/WorkflowStepLink.js